import React, { useState } from 'react'
import classNames from 'classnames/bind'

import { Atbash } from './atbash/Atbash'
import { Caesar } from './caesar/Caesar'
import { Qwerty } from './qwerty/Qwerty'
import styles from './cipher-page.scss'

const cx = classNames.bind(styles)

export const CipherPage = () => {
    const cipherList = ['atbash', 'caesar', 'qwerty']
    const [cypher, setCypher] = useState(cipherList[1])

    const updateCipher = (cipher) => {
        setCypher(cipher)
    }

    const alphabet = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z']

    // Programmatically create the association vs manually creating it.
    const alphabetKey = () => {
        let alphabetObject = {}

        for (let i = 0; i < alphabet.length; i++) {
            alphabetObject[alphabet[i]] = i
        }

        return alphabetObject
    }

    return (
        <div className={cx("cipher-page-wrapper")}>
            <div className="container">
                <h1>Ciphers</h1>

                <p>
                    Ciphers are used to send secret messages to people in visible
                    sight without being easily noticed by other people. This page
                    was put together to help encode/decode ciphers, as my family
                    enjoys using them for the 'Hunt a Killer' game.
                </p>

                <p>Select the type of Cipher you would like to use.</p>

                <select
                    name="ciphers"
                    onChange={(e) => updateCipher(e.target.value)}
                    className="col-2"
                    defaultValue={cypher}
                >
                    {cipherList.map((cipher) => {
                        return <option value={cipher} key={cipher}>{cipher}</option>
                    })}
                </select>

                {cypher === 'atbash' && <Atbash alphabetKey={alphabetKey()} alphabet={alphabet} />}
                {cypher === 'caesar' && <Caesar alphabetKey={alphabetKey()} alphabet={alphabet} />}
                {cypher === 'qwerty' && <Qwerty alphabetKey={alphabetKey()} alphabet={alphabet} />}
            </div>
        </div>
    )
}
